import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { CLINICAL_FONT_FAMILY } from "../components/shared/constants";

export const Footer: React.FC = () => {
  return (
    <Paper
      component="footer"
      elevation={0}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(8px)",
        borderTop: "1px solid #E2E8F0",
        py: 1,
        px: 3,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        display: { xs: "none", md: "block" }, // Hide on mobile
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "#64748B",
            fontFamily: CLINICAL_FONT_FAMILY,
            fontSize: "0.75rem",
          }}
        >
          © 2025 AIClinTrack. All rights reserved.
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#9CA3AF",
            fontFamily: CLINICAL_FONT_FAMILY,
            fontSize: "0.75rem",
          }}
        >
          Clinical Trial Management System
        </Typography>
      </Box>
    </Paper>
  );
};
